/**
 * base-model
 * Copyright (c) 2016 Taillight LLC
 */

export class LegacyLink {
    LegacyApplication: string;
    LegacyTableId: string;
}

export class BaseModel {
    Id: string;
    IsActive: Boolean;
    IsDeleted: Boolean;
    TimeStamp: string;
    LegacyLinks: Array<LegacyLink>;
}